"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _default = {
  PropTypes: {
    controls: _propTypes.default.shape({
      calendarIndex: _propTypes.default.number,
      showPrevButton: _propTypes.default.bool,
      year: _propTypes.default.any,
      month: _propTypes.default.any,
      enablePrevButton: _propTypes.default.bool,
      selectForDepart: _propTypes.default.bool,
      selectForReturn: _propTypes.default.bool,
      maxDate: _propTypes.default.instanceOf(Date),
      maxDays: _propTypes.default.number,
      selectionType: _propTypes.default.number,
      resetData: _propTypes.default.bool,
      dataFormatDate: _propTypes.default.object,
      dataFormatCurrency: _propTypes.default.object,
      maxDisplayedDate: _propTypes.default.instanceOf(Date),
      onDepartSelected: _propTypes.default.func,
      onReturnSelected: _propTypes.default.func,
      onPrevButtonClicked: _propTypes.default.func,
      showDaysDisplay: _propTypes.default.bool,
      currency: _propTypes.default.string,
      customDateLabels: _propTypes.default.object
    }),
    data: _propTypes.default.shape({
      departDate: _propTypes.default.shape({
        year: _propTypes.default.any,
        month: _propTypes.default.any,
        date: _propTypes.default.any
      }),
      returnDate: _propTypes.default.shape({
        year: _propTypes.default.any,
        month: _propTypes.default.any,
        date: _propTypes.default.any
      })
    }),
    lfcPrices: _propTypes.default.shape({
      oneway: _propTypes.default.object,
      return: _propTypes.default.object
    }),
    snapLfcPrices: _propTypes.default.object,
    exchangeRate: _propTypes.default.number,
    theme: _propTypes.default.string,
    isOnlyApplyForHotel: _propTypes.default.bool,
    isSnapCalendar: _propTypes.default.bool,
    isPartialHotelCalendar: _propTypes.default.bool,
    flightDepart: _propTypes.default.instanceOf(Date),
    flightReturn: _propTypes.default.instanceOf(Date),
    minNights: _propTypes.default.number,
    enableAvailableDateCalendarFlag: _propTypes.default.bool
  },
  DefaultProps: {
    exchangeRate: 1,
    isOnlyApplyForHotel: false,
    isSnapCalendar: false,
    snapLfcPrices: null,
    isPartialHotelCalendar: false,
    enableAvailableDateCalendarFlag: false
  }
};
exports.default = _default;